module.exports = __webpack_public_path__ + "img/observatorio-logo-completo.841db1e3.png";